import TemplateMixin from './TemplateMixin';
import { Component, Mixins } from 'vue-property-decorator';

@Component({})
export default class ImageTemplate extends Mixins(TemplateMixin) {
  get src(): string {
    return this.component.value;
  }
}
